const header = (): void => {
  const classes = {
    hamburgerOpen: 'header-nav__hamburger--open',
    searchModalOpen: 'body--search-modal-open',
    mobileNavOpen: 'body--mobile-nav-open',
  };

  const selectors = {
    mobileMenuToggle: '[data-mobile-menu-toggle]',
    mobileNavOverlay: '[data-mobile-nav-overlay]',
    searchModalToggle: '[data-search-modal-toggle]',
    searchModalInput: '[data-search-form] [type="search"]',
  };

  const mobileMenuToggle = document.querySelector(selectors.mobileMenuToggle);
  const mobileNavOverlay = document.querySelector(selectors.mobileNavOverlay);

  mobileMenuToggle.addEventListener('click', () => {
    document.body.classList.remove(classes.searchModalOpen);
    mobileMenuToggle.classList.toggle(classes.hamburgerOpen);
    document.body.classList.toggle(classes.mobileNavOpen);
  });

  mobileNavOverlay.addEventListener('click', () => {
    document.body.classList.remove(classes.mobileNavOpen);
    mobileMenuToggle.classList.remove(classes.hamburgerOpen);
  });

  const stickyHeader = (): void => {
    const body = document.body;
    const scrollUp = 'body--scrolling-up';
    const scrollDown = 'body--scrolling-down';
    let lastScroll = 0;

    const scrollPositionEvents = ['load', 'scroll'];
    scrollPositionEvents.forEach((event) => {
      window.addEventListener(event, () => {
        const currentScroll = window.scrollY;
        if (currentScroll <= 0) {
          body.classList.remove(scrollUp);
          return;
        }
        if (
          currentScroll > lastScroll &&
          !body.classList.contains(scrollDown)
        ) {
          body.classList.remove(scrollUp);
          body.classList.add(scrollDown);
        } else if (
          currentScroll < lastScroll &&
          body.classList.contains(scrollDown)
        ) {
          body.classList.remove(scrollDown);
          body.classList.add(scrollUp);
        }
        lastScroll = currentScroll;
      });
    });
  };

  stickyHeader();

  const searchModal = (): void => {
    const searchFormInput = document.querySelector<HTMLInputElement>(
      selectors.searchModalInput
    );
    const searchModalToggle = document.querySelectorAll(
      selectors.searchModalToggle
    );
    if (searchModalToggle) {
      searchModalToggle.forEach((toggle) => {
        toggle.addEventListener('click', () => {
          document.body.classList.remove(classes.mobileNavOpen);
          mobileMenuToggle.classList.remove(classes.hamburgerOpen);

          if (document.body.classList.contains(classes.searchModalOpen)) {
            document.body.classList.remove(classes.searchModalOpen);
          } else {
            document.body.classList.add(classes.searchModalOpen);
            if (searchFormInput) {
              searchFormInput.focus();
            }
          }
        });
      });
    }
  };

  searchModal();
};

export default header;
